import { jobs } from '../behavior/jobs-sidecar'
import { blueprints } from '../blueprints/blueprints-sidecar'
import { blueprintsData } from '../blueprints/blueprintsData-sidecar'
import { tileMapEditor } from '../editor/tileMapEditor-sidecar'
import { settings } from '../engine/settings-sidecar'
import { stevieCam } from '../engine/stevieCam-sidecar'
import { asteroids } from '../entities/asteroids-sidecar'
import { asteroidsData } from '../entities/asteroidsData-sidecar'
import { cargoes } from '../entities/cargoes-sidecar'
import { cargoesData } from '../entities/cargoesData-sidecar'
import { objects } from '../entities/objects-sidecar'
import { particles } from '../entities/particles-sidecar'
import { fullnessIndicators } from '../indicators/fullnessIndicators-sidecar'
import { healthBars } from '../indicators/healthBars-sidecar'
import { progressIndicators } from '../indicators/progressIndicators-sidecar'
import { keyboard } from '../input/keyboard-sidecar'
import { mouseWheel } from '../input/mouseWheel-sidecar'
import { machines } from '../machines/machines-sidecar'
import { machinesData } from '../machines/machinesData-sidecar'
import { modelActorCollector } from '../models/modelActorCollector-sidecar'
import { IOxygenModel } from '../models/oxygenModel'
import { oxygenModel } from '../models/oxygenModel-sidecar'
import { IModelRenderer } from '../models/oxygenModelRenderer'
import { oxygenModelRenderer } from '../models/oxygenModelRenderer-sidecar'
import { runBuildingModel } from '../models/runBuildingModel-sidecar'
import { runModel } from '../models/runModel-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { monstersAnims } from '../monsters/monstersAnims-sidecar'
import { monstersData } from '../monsters/monstersData-sidecar'
import { sounds } from '../sounds/sounds-sidecar'
import { buildSelectors } from '../tiles/buildSelectors-sidecar'
import { ITileMapShip } from '../tiles/tileMapShip'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { tileTiler } from '../tiles/tileTiler-sidecar'
import { ICursor } from '../ui/cursors'
import { cursors } from '../ui/cursors-sidecar'
import { machinePlacer } from '../ui/machinePlacer-sidecar'
import { monsterSelector } from '../ui/monsterSelector-sidecar'
import { pathHighlights } from '../ui/pathHighlights-sidecar'
import { uiBuild } from '../ui/uiBuild-sidecar'
import { uiDebug } from '../ui/uiDebug-sidecar'
import { uiMode } from '../ui/uiMode-sidecar'
import { uiNewGame } from '../ui/uiNewGame-sidecar'
import { uiNewMap } from '../ui/uiNewMap-sidecar'
import { uiOpenMap } from '../ui/uiOpenMap-sidecar'
import { uiOxygen } from '../ui/uiOxygen-sidecar'
import { uiSpeedBar } from '../ui/uiSpeedBar-sidecar'
import { uiStack } from '../ui/uiStack-sidecar'
import { uiStart } from '../ui/uiStart-sidecar'
import { uiStats } from '../ui/uiStats-sidecar'
import { uiTileSelector } from '../ui/uiTileSelector-sidecar'
import { uiTooltips } from '../ui/uiTooltips-sidecar'
import { uiTravel } from '../ui/uiTravel-sidecar'
import { buttons } from '../uiParts/buttons-sidecar'
import { checkboxes } from '../uiParts/checkboxes-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'
import { dialogs } from '../uiParts/dialogs-sidecar'
import { IFontData } from '../uiParts/fontData'
import { fontData } from '../uiParts/fontData-sidecar'
import { stevieText } from '../uiParts/stevieText-sidecar'
import { textInputs } from '../uiParts/textInputs-sidecar'
import { common } from './common-sidecar'
import { gameRunner } from './gameRunner-sidecar'
import { layers } from './layers-sidecar'
import { spriteMap } from './spriteMap-sidecar'

export interface IContext {
  mapShip: ITileMapShip
  model: IOxygenModel
  modelRenderer: IModelRenderer
  cursor: ICursor
  font32: IFontData
  font24: IFontData
  font16: IFontData
  speedScale: number
}

let context: IContext | null = null
export const getContext = () => {
  if (!context) {
    throw new Error('context not ready!')
  }
  return context
}

export const create = () => {
  settings.create('dungeon:settings', 1)

  const soundsJson = common.getPhaserScene().cache.json.get('audioSprite1')
  sounds.load(soundsJson, '')

  monstersData.createData()
  cargoesData.createData()
  machinesData.createData()
  asteroidsData.createData()
  blueprintsData.createData()

  layers.create()
  spriteMap.create()
  let font32 = fontData.create('oryx_32px', {
    spaceWidth: 0,
    widthAdjust: 0,
  })
  let font24 = fontData.create('oryx_24px', { spaceWidth: 0, widthAdjust: 0 })
  let font16 = fontData.create('oryx_16px', { spaceWidth: 0, widthAdjust: 0 })

  clickEater.create()
  keyboard.create()
  mouseWheel.create()

  tilesDataShip.create()

  monstersAnims.createData()

  uiTileSelector.create()
  // uiOpenMap.create()

  // let map = tileMap.createTileMap()
  let mapShip = tileMapShip.createTileMapShip()

  let cursor = cursors.create()

  let model = oxygenModel.createModel(mapShip.width, mapShip.height)
  let modelRenderer = oxygenModelRenderer.createRenderer(model)

  let ll = layers.getLayers()
  ll.gasses.x = mapShip.ox
  ll.gasses.y = mapShip.oy

  context = {
    // map,
    mapShip,
    cursor,
    font16,
    font24,
    font32,
    model,
    modelRenderer,
    speedScale: 1,
  }

  postCreate()
}

export const postCreate = () => {
  let ctx = getContext()

  tileMapEditor.newMap()

  if (!settings.get().skipStart) {
    uiStart.open()
  } else {
    startGame()
  }
}

export const startGame = () => {
  // uiPreferences.open()

  gameRunner.doRetry()

  // uiLevelWin.open()
}

export const update = (time: number, delta: number) => {
  let ctx = getContext()
  common.setUpdateDelta(delta / 1000)
  common.setUpdateDeltaScaled((delta / 1000) * ctx.speedScale)

  clickEater.updateAll()

  uiSpeedBar.update()
  uiMode.update()
  buttons.updateAll()
  dialogs.updateAll()

  particles.updateAll()
  monsters.updateAll()
  cargoes.updateAll()
  // stacks.updateAll()
  machines.updateAll()
  healthBars.updateAll()
  fullnessIndicators.updateAll()
  progressIndicators.updateAll()
  objects.updateAll()
  asteroids.updateAll()
  blueprints.updateAll()

  cursors.updateAll()

  monsterSelector.update()
  uiTileSelector.update()

  uiTooltips.update()
  uiOpenMap.update()
  uiNewMap.update()
  // uiSpawn.update()
  uiStart.update()

  uiStats.update()
  uiTravel.update()
  uiNewGame.update()
  uiBuild.update()
  uiStack.update()
  uiOxygen.update()
  uiDebug.update()

  gameRunner.update()

  checkboxes.updateAll()
  textInputs.updateAll()
  stevieText.updateAll()
  buildSelectors.updateAll()

  pathHighlights.updateAll()
  // pathHighligher.update()
  // pathFinder.update()
  jobs.updateAll()

  stevieCam.update()

  machinePlacer.updateAll()
  tileMapShip.updateAll()

  // Pretty late so other clicks get eaten first
  tileMapEditor.update()

  tileTiler.tileTiles(ctx.mapShip)

  // Gases model (move to thread)
  // let t0 = performance.now()
  oxygenModel.setModelActors(
    ctx.model,
    modelActorCollector.collectModelActors(),
  )
  oxygenModel.syncGrid(ctx.model, modelActorCollector.collectSyncs())
  runModel.run(ctx.model)

  // TODO: only on tilemap changes
  // let t0 = performance.now()
  runBuildingModel.run(ctx.model)
  // let t1 = performance.now()
  // console.log('building ms', t1 - t0)
  oxygenModelRenderer.update(ctx.modelRenderer, ctx.model)
  // let s = getScene()
  //s.map.
}
